<template>
  <div class="mb-2 d-print-none" v-if="userStore.isLoggedIn">
    <v-app-bar color="primary" floating flat dense width="100%">
      <v-app-bar-nav-icon
        class="hidden-md-and-up ml-0"
        color="white"
        @click="showDrawer = true"
      />
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn exact icon :to="{ name: 'home' }">
          <v-icon color="white">fa-home</v-icon>
        </v-btn>
        <!--        Sports menu-->
        <v-menu
          offset-y
          bottom
          ref="menu"
          :close-on-content-click="false"
          v-if="userStore.isStaff"
          :value="showMenu"
        >
          <template v-slot:activator="{ on }">
            <a
              class="v-btn v-size--default v-btn--router v-btn--text theme--light"
              @click.stop="showMenu = true"
              v-on="on"
            >
              <span>Sports</span>
            </a>
          </template>
          <v-list>
            <v-list-group
              v-for="sport in listOfValues.sports"
              :key="sport.value"
              v-model="sport.active"
              no-action
            >
              <template v-slot:activator>
                <v-list-item-title class="font-weight-bold">{{
                  sport.text
                }}</v-list-item-title>
              </template>

              <v-list-item
                v-for="division in listOfValues.divisions"
                :key="division.value"
                link
              >
                <v-list-item-title
                  @click="
                    changeSportCodeAndDivision(sport.value, division.value)
                  "
                  class="v-btn--router"
                  >Division {{ division.text }}</v-list-item-title
                >
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-menu>

        <v-menu
          offset-y
          bottom
          ref="menu"
          :close-on-content-click="false"
          v-else
          :value="showMenu"
        >
          <template v-slot:activator="{ on }">
            <a
              class="v-btn v-size--default v-btn--router v-btn--text theme--light"
              @click.stop="showMenu = true"
              v-on="on"
            >
              <span>Sports</span>
            </a>
          </template>
          <v-list>
            <v-list-item
              v-for="year in yearStore.years"
              :key="year.championship_team_id"
              link
            >
              <v-list-item-title
                @click="changeYear(year)"
                class="v-btn--router"
                >{{
                  year.sportCode === "MTE" ? "Men's Tennis" : "Women's Tennis"
                }}</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>

        <v-btn
          v-for="navItem in navItems"
          :key="navItem.label"
          text
          :class="{ 'v-btn--active': navItem.active }"
          :to="navItem.route"
          exact
          >{{ navItem.label }}</v-btn
        >

        <v-btn
          text
          v-if="showChallengeInMenu"
          :to="route"
          :class="{ 'v-btn--active': true }"
        >
          Challenge
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>

    <v-navigation-drawer
      app
      class="hidden-md-and-up"
      color="primary"
      dark
      height="100%"
      hide-overlay
      v-model="showDrawer"
    >
      <v-list-item>
        <v-list-item-avatar class="avatar-border">
          <img
            :src="userStore.isStaff ? ncaaSmallLogo : userStore.user.orgLogoUrl"
            alt="Logo"
          />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ userStore.user.name }}</v-list-item-title>
          <v-list-item-subtitle>
            <small>{{ userStore.user.org_name }}</small>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider />
      <v-menu
        offset-y
        bottom
        ref="menu"
        :close-on-content-click="false"
        v-if="userStore.isStaff"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-list nav dense>
            <v-list-item v-on="on" v-bind="attrs">
              <v-list-item-title>Sports</v-list-item-title>
            </v-list-item>
            <v-divider />
          </v-list>
        </template>
        <v-list>
          <v-list-group
            v-for="sport in listOfValues.sports"
            :key="sport.value"
            v-model="sport.active"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-title>{{ sport.text }}</v-list-item-title>
            </template>

            <v-list-item
              v-for="division in listOfValues.divisions"
              :key="division.value"
              link
            >
              <v-list-item-title
                @click="changeSportCodeAndDivision(sport.value, division.value)"
                class="v-btn--router"
                >Division {{ division.text }}</v-list-item-title
              >
            </v-list-item>
          </v-list-group>
        </v-list>
      </v-menu>

      <v-menu offset-y bottom ref="menu" v-else>
        <template v-slot:activator="{ on, attrs }">
          <v-list nav dense>
            <v-list-item v-bind="attrs" v-on="on">
              <v-list-item-title>Sports</v-list-item-title>
            </v-list-item>
            <v-divider />
          </v-list>
        </template>
        <v-list>
          <v-list-item v-for="(year, index) in yearStore.years" :key="index">
            <v-list-item-title
              @click="changeYear(year)"
              class="v-btn--router"
              style="cursor: pointer"
              >{{
                year.sportCode === "MTE" ? "Men's Tennis" : "Women's Tennis"
              }}</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-menu>

      <v-list nav dense>
        <v-list-item :to="{ name: 'home' }" exact>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item>

        <v-list-item
          v-for="navItem in navItems"
          :key="navItem.label"
          :to="navItem.route"
        >
          <v-list-item-title>{{ navItem.label }}</v-list-item-title>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <div class="pa-2">
          <v-btn block light :to="{ name: 'logout' }" class="red--text">
            <v-icon left> fa-sign-out-alt</v-icon>
            Log Out
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script setup>
import { useUserStore } from "../../store/user";
import { useYearStore } from "../../store/yearStore";
import ncaaSmallLogo from "~/images/NCAA_flat_sm.png";
import { useListOfValuesStore } from "../../store/listOfValuesStore";
import { useAdminStore } from "../../store/adminStore";
import Vue, { ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router/composables";
const userStore = useUserStore();
const adminStore = useAdminStore();
const yearStore = useYearStore();
const listOfValues = useListOfValuesStore();
const showMenu = ref(false);
const route = useRoute();
const router = useRouter();

const showDrawer = ref(false);

// This method is called by admins when they use the two level dropdown to change year.
function changeSportCodeAndDivision(sport, division) {
  this.showMenu = false;
  yearStore.setSportCodeAndDivision(sport, division);
  // now redirect to school listing if staff and we are viewing lineupForm route
  if (route.name === "lineupForm") {
    router.push({
      name: "schools",
    });
  }
}
// This level is called by non-staff when they use a one level dropdown.
function changeYear(year) {
  this.showMenu = false;
  yearStore.setYearObject(year);
  // If championship team id is present show the form.
  if (year.championshipTeamId)
    router.replace({
      name: "lineupForm",
      params: { id: year.championshipTeamId, yearId: yearStore.year.id },
    });
  // otherwise take the committee member to the selected school list page of the non-sponsored sport.
  else if (
    this.adminStore.selectedSchoolListAvailable ||
    this.userStore.isCommitteeMember
  )
    router.replace({
      name: "yearSelectedSchoolList",
      params: { yearId: yearStore.year.id },
    });
  else {
  }
}
const staffNav = computed(() => {
  const staffNavItems = [
    {
      label: "Schools",
      route: { name: "schools" },
    },
    {
      label: "Challenges",
      route: { name: "challenges" },
    },
  ];

  if (route.path.includes("challenge")) {
    staffNavItems[1].active = true;
  } else if (route.path.includes("schools")) {
    staffNavItems[0].active = true;
  }

  if (userStore.isNcaaAppAdmin) {
    staffNavItems.push({
      label: "Admin",
      route: { name: "formText" },
    });
  }

  return staffNavItems;
});

const schoolNav = computed(() => {
  const schoolNavItems = [];

  if (!yearStore.year) return schoolNavItems;

  if (yearStore.year.championshipTeamId) {
    schoolNavItems.push({
      label: "Lineup Form",
      route: {
        name: "lineupForm",
        params: {
          id: yearStore.year.championshipTeamId,
          yearId: yearStore.year.id,
        },
      },
    });
  }

  if (adminStore.selectedSchoolListAvailable || userStore.isCommitteeMember) {
    schoolNavItems.push({
      label: "Selected Schools",
      route: {
        name: "yearSelectedSchoolList",
        params: { yearId: yearStore.year.id },
      },
    });
  }

  if (userStore.isCommitteeMember && adminStore.committeeChallengesAvailable) {
    schoolNavItems.push({
      label: "Challenges",
      route: { name: "challenges" },
    });
  } else if (adminStore.myChallengesAvailable) {
    schoolNavItems.push({
      label: "My Challenges",
      route: {
        name: "mychallenges",
        params: { yearId: yearStore.year.id },
      },
    });
  }
  return schoolNavItems;
});

const navItems = computed(() => {
  return userStore.isStaff ? staffNav.value : schoolNav.value;
});

const showChallengeInMenu = computed(() => {
  return (
    !userStore.isStaff &&
    !userStore.isCommitteeMember &&
    route.path.includes("challenge") &&
    route.name !== "mychallenges"
  );
});
</script>

<style>
.avatar-border {
  border: 1px solid white;
}

header.v-app-bar > .v-toolbar__content {
  padding: 0 !important;
}

.v-toolbar__items > button {
  font-weight: 700 !important;
}
</style>
